export const AP_INVOICE = "apInvoiceApprovals";
export const BUDGET = "budgetApprovals";
export const CONTRACT = "contractApprovals";
export const WORK_ORDER = "workOrderApprovals";
export const BLANKET_LIMIT = "autoApprovalBlanketLimit";
export const SINGLE_APPROVAL = "singleLevelTotalLimit";
export const BOARD_LEVEL_APPROVAL = "boardTotalLimit";
export const PM_APPROVAL_LIMIT = "pmLimit";
export const PM_YEARLY_LIMIT = "pmTotalLimit";
